module.exports = __webpack_public_path__ + "static/media/curriculumKit__car.14a94bad.svg";